import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function BizeUlasin() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const contactInfo = [{
    icon: Phone,
    label: "Telefon",
    value: "+90 554 842 15 37",
    href: "tel:+905548421537",
    actionLabel: "Hemen Arayın"
  }, {
    icon: Mail,
    label: "E-posta",
    value: "av.celik@mail.com",
    href: "mailto:av.celik@mail.com",
    actionLabel: "E-posta Gönderin"
  }, {
    icon: MapPin,
    label: "Adres",
    value: "Kutlubey Mah. Cengiz Topel Cad. 1006 Sk. No:31/1 Merkez/ISPARTA",
    href: "https://www.google.com/maps/search/?api=1&query=Av.+Arb.+Muhammed+Üsame+Çelik+Kutlubey+Mah.+Cengiz+Topel+Cad.+1006+Sk.+No:31/1+Merkez/ISPARTA",
    actionLabel: "Yol Tarifi Alın"
  }];
  return <section id="bize-ulaşın" ref={ref} className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_45%)] opacity-10 blur-3xl" />

      <div className="container relative mx-auto px-6">
        {}
        <div className={cn("mb-20 text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="font-serif text-5xl font-medium tracking-tight text-white sm:text-6xl lg:text-7xl">İLETİŞİM</h1>
          <div className="bg-primary mx-auto mt-6 h-1 w-24 opacity-60" />
        </div>

        {}
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 lg:gap-16">
          {contactInfo.map((item, i) => <div key={i} data-index={i} className={cn("group flex flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")} style={{
          transitionDelay: `${i * 150 + 200}ms`
        }}>
              {}
              <div className="bg-accent/10 text-primary mb-6 flex size-16 items-center justify-center rounded-full ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-110 group-hover:bg-white/5 group-hover:text-white">
                <item.icon className="size-7" strokeWidth={1.5} />
              </div>

              {}
              <h3 className="text-muted-foreground mb-3 text-sm font-medium uppercase tracking-widest">
                {item.label}
              </h3>

              {}
              <p className="text-foreground mb-6 max-w-[280px] text-lg font-light leading-relaxed text-balance">
                {item.value}
              </p>

              {}
              <Link to={item.href} className="text-primary hover:text-white inline-flex items-center gap-2 text-sm font-medium transition-colors duration-300" newTab={item.label === "Adres"}>
                <span>{item.actionLabel}</span>
                <span className="text-lg leading-none transition-transform duration-300 group-hover:translate-x-1">
                  &rarr;
                </span>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}